export default (data) => async (dispatch) => {
  dispatch({
    type: 'EDITOR/GET_SNAPSHOT',
    payload: data,
  });
};
